import React from 'react';

const OverviewTab = ({ caseData, partner }) => {
  if (!caseData) return <div>Laden...</div>;

  // Use case-embedded partner data as fallback if partner lookup failed
  const partnerFirma = partner?.company_name || caseData.partner_firma || '-';
  const partnerAnsprechpartner = partner?.contact_name || 
    (partner?.contact_first_name && partner?.contact_last_name 
      ? `${partner.contact_first_name} ${partner.contact_last_name}` 
      : caseData.partner_ansprechpartner) || '';
  const partnerEmail = partner?.email || caseData.partner_email || '';

  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
          <h3 className="font-bold text-gray-900 mb-4">Partnerdaten</h3>
          <div className="space-y-2 text-sm">
            <div><span className="font-semibold">Firma:</span> {partnerFirma}</div>
            <div><span className="font-semibold">Ansprechpartner:</span> {partnerAnsprechpartner}</div>
            <div><span className="font-semibold">E-Mail:</span> {partnerEmail}</div>
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
          <h3 className="font-bold text-gray-900 mb-4">Auftragsdaten</h3>
          <div className="space-y-2 text-sm">
            <div><span className="font-semibold">Schadentag:</span> {caseData.damage_date || '-'}</div>
            <div><span className="font-semibold">Schadenort:</span> {caseData.damage_street ? `${caseData.damage_street}, ${caseData.damage_zip} ${caseData.damage_city}` : caseData.damage_location || '-'}</div>
            <div><span className="font-semibold">Kennzeichen:</span> {caseData.license_plate || '-'}</div>
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
          <h3 className="font-bold text-gray-900 mb-4">Fahrzeugdaten</h3>
          <div className="space-y-2 text-sm">
            <div><span className="font-semibold">Fahrzeug:</span> {caseData.vehicle_manufacturer} {caseData.vehicle_model}</div>
            <div><span className="font-semibold">KM-Stand:</span> {caseData.vehicle_mileage ? `${caseData.vehicle_mileage} km` : '-'}</div>
            <div><span className="font-semibold">Schadenzone:</span> {caseData.damage_zone || '-'}</div>
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
          <h3 className="font-bold text-gray-900 mb-4">Schadenbeschreibung</h3>
          <div className="space-y-3 text-sm">
            {/* Aktueller Schaden */}
            <div>
              <span className="font-semibold text-red-700">Aktueller Schaden (Unfall):</span>
              <div className="text-xs text-gray-700 mt-1 p-3 bg-red-50 rounded-lg border border-red-200">
                {caseData.damage_description || 'Keine Beschreibung'}
              </div>
            </div>
            
            {/* Vorschäden */}
            <div>
              <span className="font-semibold text-yellow-700">Vorschäden (vor dem Unfall):</span> {caseData.pre_damage || 'Nicht angegeben'}
              {caseData.pre_damage === 'Ja' && caseData.pre_damage_description && (
                <div className="text-xs text-gray-700 mt-1 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                  {caseData.pre_damage_description}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
